import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { checkDesignTypeByUsage } from '../../lib/MyDesignParser';
import { replaceAllSpaces } from '../../lib/utils';
import { MyDesign } from '../../models/MyDesign';
import { Loading } from '../shared/Loading';
import { MyDesignCanvas } from './MyDesignCanvas';

const uploadedDesignStyles = css`
  display: flex;
  background: white;
  border-radius: 16px;
  padding: 20px 24px;
  position: relative;
  width: 100%;
  transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), color 0.2s;
  &:active {
    transform: scale(0.98);
  }
  &:disabled {
    pointer-events: none;
  }
  .image {
    flex: 0 0 auto;
    width: 64px;
    height: 64px;
    overflow: hidden;
    margin-right: 12px;
    marker-end: 12px;
  }
  .texts {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow: hidden;
    text-align: left;
    text-align: start;
  }
  .title,
  .creator {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .creator,
  .usage {
    font-size: 12px;
    color: #938666;
    margin: 4px 0 0;
  }
  .title {
    font-size: 16px;
    color: #4d3906;
  }
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.8);
  }
`;

interface UploadedDesignProps {
  myDesign: MyDesign;
  isLoading: boolean;
}

export const UploadedDesign: React.FC<UploadedDesignProps> = ({ myDesign, isLoading }) => {
  const history = useHistory();
  const { t } = useTranslation('my_design');
  const { title, creator, designType, paletteColors, colorData, usage } = myDesign;
  const canvasSize = 64;
  const handleClick = () => {
    history.push(`/players/my-design/detail`);
  };

  return (
    <button className={uploadedDesignStyles} disabled={isLoading} onClick={handleClick}>
      <div className="image">
        <MyDesignCanvas {...{ designType, paletteColors, colorData, usage, canvasSize }} />
      </div>
      <div className="texts">
        <label className="title">{replaceAllSpaces(title)}</label>
        {/* eslint-disable-next-line eqeqeq */}
        {usage != undefined && checkDesignTypeByUsage(usage) === 'pro' ? (
          <label className="usage">{t(`usage_00${usage}`)}</label>
        ) : (
          undefined
        )}
        <label className="creator">{replaceAllSpaces(creator)}</label>
      </div>
      {isLoading && (
        <div className="loading">
          <Loading />
        </div>
      )}
    </button>
  );
};
